import React, { useState } from "react";
import OwlCarousel from "react-owl-carousel";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";



const imageMap = [
  {
    image_black: "/assets/images/mist/vision-white-icon.png",
    image_white: "/assets/images/mist/vision-white-icon.png",
  },
  {
    image_black: "/assets/images/mist/mission-white-icon.png",
    image_white: "/assets/images/mist/mission-white-icon.png",
  },
  {
    image_black: "/assets/images/mist/value-white-icon.png",
    image_white: "/assets/images/mist/value-white-icon.png",
  },
];


function CardTrioVisionMissionValue({
  principles,
  siteType,
  defaultHeadings = ["Vision:", "Mission:", "Values:"],
}) {
  const [showModal, setShowModal] = useState(false);
  const [selectedContent, setSelectedContent] = useState({});
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const CHAR_LIMIT = 90;

  if (!principles?.length || siteType !== "hospitals") return null;

  const handleReadMore = (data) => {
    setSelectedContent(data);
    setShowModal(true);
  };

  const stripHtml = (html) => {
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };

  const truncateWithReadMore = (html, data) => {
    const plainText = stripHtml(html);
    if (plainText.length <= CHAR_LIMIT) return html;

    const truncatedText = plainText.slice(0, CHAR_LIMIT);

    return `${truncatedText}... <span class="fw-bold" style="cursor:pointer;" onclick="window.__readMoreHandler('${data.heading}')">Read More</span>`;
  };

  // Expose global handler
  window.__readMoreHandler = (heading) => {
    const matched = principles.find((item) => item.heading === heading);
    if (matched) handleReadMore(matched);
  };

  const renderContentBox = (data, index, isMobile = false) => {
    const displayText = truncateWithReadMore(
      data?.description || "No Description Found",
      data
    );



    const imageSrc =
      hoveredIndex === index
        ? imageMap[index]?.image_white
        : imageMap[index]?.image_black;

    return (
      <div
        key={index}
        className={`feature-box-wrap f-box-style-3 my-4 ${isMobile
          ? "relative mission-feature-box-wrap mt-5 pt-5"
          : "animated fadeInDown relative mission-feature-box-wrap"
          }`}
        onMouseEnter={() => setHoveredIndex(index)}
        onMouseLeave={() => setHoveredIndex(null)}
      >
        <div className="feature-box-details boxhighlighted-mission-hover">
          <div className="feature-icon mb-3 text-center">
            {imageSrc ? (
              <img
                src={imageSrc}
                alt=""
                style={{ width: "40px", height: "40px" }}
              />
            ) : (
              <i className="bi bi-buildings theme-color"></i>
            )}
            {/* {data?.image ? (
              <img
                src={data?.image}
                alt=""
                style={{ width: "40px", height: "40px" }}
              />
            ) : (
              <span className="ti-flag-alt b-radius-50"></span>
            )} */}
          </div>
          <div className="feature-content">
            <div className="feature-title text-center relative margin-bottom-10">
              <h4>{data?.heading || defaultHeadings[index]}</h4>
            </div>
            <p className="mb-0 text-center text-black">
              <span
                dangerouslySetInnerHTML={{
                  __html: displayText,
                }}
              />
            </p>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
    <div className="container">
      {/* Desktop View */}
      <div className="home-intro-desktop mt-5">
        <div className="row">
          {principles.map((data, index) => (
            <div className="col-lg-4 pad-top-md-30" key={`desktop-${index}`}>
              {renderContentBox(data, index)}
            </div>
          ))}
        </div>
      </div>

      {/* Mobile View */}
      <div className="home-intro-mobile-view">
        <div className="row">
          <OwlCarousel
            className="service-main-wrapper"
            loop
            nav={false}
            dots={false}
            autoplay={true}
            autoplayTimeout={2500}
            autoplayHoverPause
            smartSpeed={1000}
            margin={30}
            responsive={{ 0: { items: 1 } }}
          >
            {principles.map((data, index) => (
              <div key={`mobile-${index}`} className="item p-1">
                {renderContentBox(data, index, true)}
              </div>
            ))}
          </OwlCarousel>
        </div>
      </div>

      {/* Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{selectedContent?.heading || "Details"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            dangerouslySetInnerHTML={{
              __html: selectedContent?.description || "No content available",
            }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="btn btn-default" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      </div>
    </>
  );
}

export default CardTrioVisionMissionValue;
